// src/components/Header/LogoHeader.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import "./css/ToHomepageBtn.css";

function ToHomepageBtn() {
  const navigate = useNavigate();

  return (
    <header className="btn-header">
      <div className="btn-container">
        <button className="transparent-button" onClick={() => navigate("/")}>
          Till Startsidan
        </button>
      </div>
    </header>
  );
}

export default ToHomepageBtn;
